import { useRef, useState, useMemo } from 'react'
import { AnimatePresence } from 'framer-motion'
import { Link } from 'react-router-dom'

import SwitcherButton from './switcherButton'
import Preview from './preview'
import Modal from './modal'

import { useLanguage } from '../../languages/language'

import { Container } from '../../styles/global'
import { DetailProjectsContainer, ProjectsContainer } from './styled'
import { ProjectType } from '../../types'

const Projects = () => {
  const { texts } = useLanguage()
  const [switcher, setSwitcher] = useState(0)
  const [category, setCategory] = useState('web')
  const listRef = useRef(null)

  const [modal, setModal] = useState(false)
  const [actualProject] = useState<ProjectType | undefined>(undefined)

  const changeSwitcher = () => {
    let prev = switcher
    if (switcher === 1) {
      setSwitcher(0)
      setCategory('web')
    } else {
      setSwitcher(prev + 1)
      setCategory('zajmy')
    }
  }

  const actualList: ProjectType[] = useMemo(() => {
    return switcher === 0
      ? (texts.web as ProjectType[])
      : (texts.interests as ProjectType[])
  }, [switcher, texts])

  if (!actualList) return null
  return (
    <>
      <Container>
        <SwitcherButton
          position={switcher}
          changeSwitcher={changeSwitcher}
        ></SwitcherButton>
        <DetailProjectsContainer>
          {switcher === 0 && (
            <AnimatePresence>
              <Link key="0" to="/eriwen">
                <Preview i={0} project={texts.eriwen}></Preview>
              </Link>
              <Link key="1" to="/voicesofthebrave">
                <Preview i={1} project={texts.voicesofthebrave}></Preview>
              </Link>
              <Link key="2" to="/soldierswhodiedinukraine">
                <Preview
                  i={2}
                  project={texts.soldierswhodiedinukraine}
                ></Preview>
              </Link>
              <Link key="3" to="/ukraineweapons">
                <Preview i={3} project={texts.ukraineweapons}></Preview>
              </Link>
              <Link key="4" to="/ctcatalogue">
                <Preview i={4} project={texts.ctcatalogue}></Preview>
              </Link>
            </AnimatePresence>
          )}
        </DetailProjectsContainer>
        <ProjectsContainer layout key={actualList.length} ref={listRef}>
          {
            <AnimatePresence>
              {actualList &&
                actualList.map((project, index) => (
                  <Link
                    to={`/${category}/${index + 1}`}
                    key={`${project.name}-${index}`}
                  >
                    <Preview i={index + 4} project={project}></Preview>
                  </Link>
                ))}
            </AnimatePresence>
          }
        </ProjectsContainer>
        {category === 'web' && (
          <>
            <h3>{texts.otherprojects}</h3>
            <ProjectsContainer>
              <AnimatePresence>
                {texts.others.map((project, index) => (
                  <Link
                    to={`/dalsi/${index + 1}`}
                    key={`${project.name}-${index}`}
                  >
                    <Preview i={index + 1} project={project}></Preview>
                  </Link>
                ))}
              </AnimatePresence>
            </ProjectsContainer>
          </>
        )}
      </Container>
      <Modal
        project={actualProject}
        active={modal}
        handleClose={() => {
          document.getElementsByTagName('html')[0].style.overflow = ''
          document.body.style.overflowY = ''

          setModal(false)
        }}
      ></Modal>
    </>
  )
}
export default Projects
